import React from 'react'
import { Button, ButtonProps, useWalletModal} from '@pancakeswap-libs/uikit'
import useI18n from 'hooks/useI18n'
import useAuth from 'hooks/useAuth'

import { useTranslation } from 'react-i18next'

const UnlockButton: React.FC<ButtonProps> = (props) => {
  const TranslateString = useI18n()
  const { login, logout } = useAuth()
  const { onPresentConnectModal } = useWalletModal(login, logout)
  const { t } = useTranslation()
  return (
    <Button onClick={onPresentConnectModal} {...props}>
      {TranslateString(292, t('Unlock Wallet'))}
    </Button>
  )
}

export default UnlockButton
